import React from 'react'
import {Icon} from '@chakra-ui/react'

const LeftIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path
                id="arrow"
                d="M17.0498 5.90009L19.0998 8.0001L10.8998 16.2001L8.3498 18.5001L37.0498 18.5001V21.5001L8.3498 21.5001L10.8998 23.8501L19.0998 32.0001L17.0498 34.1001L2.9498 20.0001L17.0498 5.90009Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default LeftIcon
